import React, { useEffect, useState, useMemo, useRef } from 'react'
import Navigation from '../../Components/Navigation'
import No from '../../Assets/Images/Login/no.svg'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import './generarCotizacion.css'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import { useSelector, useDispatch } from 'react-redux'
import {
  addComment,
  guardarCotizacion,
  mostrarDescuento,
  addChannel,
  searchSalesDocumentDetail,
  saveQuoteColumnsSilent,
} from '../../redux/actions/cotizacionActions.js'
import { searchSalesDocumentDetailService } from 'redux/services/cotizacionServices'
import { BoxArrowUp } from 'react-bootstrap-icons'
import { useParams, useHistory } from 'react-router-dom'
import FilteringTable from '../../Components/FilteringTable'
import {
  FormatedDate,
  isCostExemptProduct,
  updateHiddenColumns,
  validateRoles,
  validatorErrorUpdate,
  validatorIsCountedCustomer,
  sanitizeOrderNumber,
} from 'Utils/functions'
import { Formatter } from 'Utils/Formatter'
import GenericModal from 'Components/GenericModal'
import ConfirmStartSalesOrder from 'Components/SalesOrder/ConfirmStartSalesOrder'
import GenerateSalesOrder from 'Components/SalesOrder/GenerateSalesOrder'
import {
  creditAccountsAction,
  getChannelsAction,
} from 'redux/actions/catalogActions'
import { ID_CONSTANTS } from 'redux/types'
import {
  CUSTOMERID,
  documentTypeId,
  salesOrderTypeIds,
  VAPermissions,
  EMPTY_GUID,
  litaAutoGeneratedChannels,
} from 'Utils/constants'
import { generateSellOrderAction } from 'redux/actions/sellOrderActions'
import MarginText from 'Components/MarginText/MarginText'
import { t } from 'i18next'
import ModalAlertCart from 'Components/ModalAlertCart/ModalAlertCart'
import { useUploadOdcFile } from 'Views/OrdenDeVenta/hooks/useUploadOdcFile'
import aa from 'search-insights'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'
import { updateProductsAuth } from 'Utils/salesOrdersUtil'
import useHandlePermission from 'Hooks/useValidatePermission'
import DeliveryDateLabel from 'Components/DeliveryDateLabel/DeliveryDateLabel'
import { useCotizationLogic } from 'Views/VentaPorProducto/hooks/useCotizationLogic'
import { updateSellerIfApplicable } from 'Utils/Helpers/updateSellerIfApplicable'
import { setServiceNote } from 'redux/actions/cotizacionActions'
import { getValidServiceNote } from 'Utils/Helpers/getValidServiceNote'
import { getYappyPayments } from 'Utils/yappyPayments'
import { isPaymentConfirmed } from 'Utils/paymentValidations'
import { QuotationPdfOptions } from 'Views/GenerarCotizacion/components/QuotationPdfOptions/QuotationPdfOptions'
import { AdditionalServiceDetailsEditor } from 'Views/GenerarCotizacion/components/AdditionalServiceDetailsEditor/AdditionalServiceDetailsEditor'
import Tints from 'Hooks/useTintsController/Tints'
import { useMarginVisibility } from 'Hooks/useMarginVisibility'
import { getMarginColumn } from 'Components/FilteringTable/columns/MarginColumn'
import { getProductDisplayText } from 'Utils/getProductDisplayText'
import { checkDuplicateOrderNumberForCustomer } from 'Utils/orderNumberValidation'
import { isWebDocumentOrigin } from 'Utils/isWebDocumentOrigin'
import { matchCartItemsToQuoteLines } from 'Utils/matchCartItemsToQuoteLines'

aa('init', {
  appId: 'ZCZRBTYD8I',
  apiKey: '6c9235a951666253b5b003e1cf34d9ce',
})

function SubtotalText() {
  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )

  return (
    <div className="money-data-text">
      <p>Sub Total</p>
      <p
        style={{
          display: showDiscountOption ? 'block' : 'none',
        }}>
        Descuento
      </p>
      <p>ITBMS</p>
      <p>Total</p>
    </div>
  )
}

function SubtotalNumbers({ setDiscount }) {
  const channelRef = useRef(null)
  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }
  const channel = channelRef.current

  const useSelectorProductos = useSelector(
    state => state.cotizacion.QuoteHeader.Lines
  )
  const cartItems = useSelector(state => state.cart.cart)

  const useSelectorDetalle = useSelector(state => state.cotizacion.QuoteHeader)
  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )
  const [subtotal, setSubTotal] = useState(0)
  const [subtotalWithDiscount, setSubtotalWithDiscount] = useState(0)
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0)

  const calcSubtotal = () => {
    let subtotal = 0
    let subtotalWithDiscount = 0
    let DiscountAmount = 0
    let additionalDiscount = 0
    useSelectorProductos.forEach(item => {
      const cartItem = cartItems.find(c => c.ProductId === item.ProductId)
      const visitDiscount = cartItem?.VisitDiscountAmount || 0
      additionalDiscount += visitDiscount
      const finalPrice =
        item.Price > item.BasePrice ? item.Price : item.BasePrice

      const negotiatedDiscount = Math.max(
        0,
        ((item.BasePrice || item.Price) - item.Price) * item.Quantity
      )
      DiscountAmount += Number(
        Formatter.Money(negotiatedDiscount, { withFormat: false })
      )
      DiscountAmount = Number(
        Formatter.Money(DiscountAmount, {
          withFormat: false,
        })
      )

      const visitDiscountAmount = cartItem?.VisitDiscountAmount || 0
      const subtotalLine = Number(
        Formatter.Money(item.Price * item.Quantity - visitDiscountAmount, {
          withFormat: false,
          decimalPrecision: 2,
          rounded: true,
        })
      )
      subtotal = Number(
        Formatter.Money(subtotalLine + subtotal, {
          withFormat: false,
        })
      )

      subtotalWithDiscount = Number(
        Formatter.Money(finalPrice * item.Quantity + subtotalWithDiscount, {
          withFormat: false,
          decimalPrecision: 2,
          rounded: true,
        })
      )
    })

    setSubTotal(
      Number(
        Formatter.Money(subtotal, {
          withFormat: false,
          decimalPrecision: 2,
          rounded: true,
        })
      )
    )
    setSubtotalWithDiscount(
      Number(
        Formatter.Money(subtotalWithDiscount, {
          withFormat: false,
        })
      )
    )
    const totalDiscount = Number(
      Formatter.Money(DiscountAmount + additionalDiscount, {
        withFormat: false,
        decimalPrecision: 2,
      })
    )
    setDiscount(totalDiscount)
    setTotalDiscountAmount(totalDiscount)

    const subTotalWithDiscountConvert = Number(
      Formatter.Money(subtotalWithDiscount, {
        withFormat: false,
      })
    )

    const subTotalConvert = Number(
      Formatter.Money(subtotal, {
        withFormat: false,
        decimalPrecision: 2,
        rounded: true,
      })
    )

    const validationDiscount = showDiscountOption
      ? subTotalWithDiscountConvert
      : subTotalConvert

    useSelectorDetalle.SubTotal = validationDiscount
    useSelectorDetalle.DiscountAmount = totalDiscount

    channel.postMessage({
      isDetailQuote: true,
      quoteData: useSelectorDetalle,
      isLoadingDetailQuote: false,
      showDiscount: showDiscountOption,
    })
  }

  useEffect(() => {
    calcSubtotal()
  }, [useSelectorProductos, showDiscountOption, cartItems])

  return (
    <div className="money-data-totals">
      <p>
        $
        {showDiscountOption
          ? Formatter.Money(subtotalWithDiscount, {
              decimalPrecision: 2,
              rounded: true,
            })
          : Formatter.Money(subtotal, {
              decimalPrecision: 2,
              rounded: true,
            })}
      </p>
      <p
        style={{
          display: showDiscountOption ? 'block' : 'none',
        }}>
        ${Formatter.Money(totalDiscountAmount)}
      </p>
      <ToolTipAmount amount={useSelectorDetalle?.Tax} isMargin />
      <ToolTipAmount amount={subtotal + useSelectorDetalle?.Tax} isMargin />
    </div>
  )
}

function GenerarCotizacion(props) {
  const quillRef = useRef(null)
  const { uploadFile } = useUploadOdcFile()
  const [comment, setComment] = useState('')
  const [discount, setDiscount] = useState(0)
  const { Channel } = useSelector(state => state.cotizacion.QuoteHeader)
  const { sellOrderPostData } = useSelector(state => state.sellOrder)
  const existingCreditAccount =
    sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountId &&
    sellOrderPostData.Data.SalesDocumentInfo.CreditAccountId !== EMPTY_GUID
      ? {
          CreditAccountId:
            sellOrderPostData.Data.SalesDocumentInfo.CreditAccountId,
          CreditAccountNumber:
            sellOrderPostData.Data.SalesDocumentInfo.CreditAccountNumber,
          Description:
            sellOrderPostData.Data.SalesDocumentInfo.CreditAccountNumber,
        }
      : null
  const [open, setOpen] = useState(false)
  const [hasRelationDocs, setHasRelationDocs] = useState(false)
  const [showChangesODVAlert, setShowChangesODVAlert] = useState(false)
  const [showModalConfirmStartSalesOrder, setShowModalConfirmStartSalesOrder] =
    useState(false)
  const [confirmStartSalesOrder, setConfirmStartSalesOrder] = useState(false)
  const [showModalGenerateSalesOrder, setShowModalGenerateSalesOrder] =
    useState(false)
  const useSelectorQuoteObject = useSelector(state => state.cotizacion)
  const [directdeliveryState] = useState(false)
  // const { isCommercialCreditSelected } = useSelector(state => state.sellOrder);
  const [showFailedSellOrderState, setShowFailedSellOrderState] =
    useState(false)
  const promisedDate = useSelectorQuoteObject?.QuoteHeader?.PromisedDate
  const [isErrorAddressModal, setIsErrorAddressModal] = useState(false)
  const [messageAddressModal, setMessageAddressModal] = useState({
    message: '',
    status: '',
  })
  const [isLoadingCreateQuote, setIsLoadingCreateQuote] = useState(false)
  const history = useHistory()

  const param = useParams()
  const user = useSelector(state => state.login.user)
  const useSelectorProductos = useSelector(
    state => state.cotizacion.QuoteHeader.Lines
  )
  const { isInstallationService } = useCotizationLogic()

  const prodWithNoCost = useSelectorProductos.filter(item => {
    const isService = item.IsService
    const isInstallation = isInstallationService(item)
    const isCostExempt = isCostExemptProduct(item)
    const hasNoCost = item.Cost === 0

    return !isService && !isInstallation && !isCostExempt && hasNoCost
  })

  const hasProdWithNoCost = useSelectorProductos.some(item => {
    const isService = item.IsService
    const isInstallation = isInstallationService(item)
    const isCostExempt = isCostExemptProduct(item)
    const hasNoCost = item.Cost === 0

    return !isService && !isInstallation && !isCostExempt && hasNoCost
  })

  const [createOdv, setCreateOdv] = useState(false)
  const company = useSelector(state => state.company)

  const canChangePriceODV = useHandlePermission(
    VAPermissions.priceOverrideAuthODV
  )

  const useSelectorDetalle = useSelector(state => state.cotizacion.QuoteHeader)

  const useEstadoGuardar = useSelector(state => state.cotizacion)
  const cartItems = useSelector(state => state.cart.cart)

  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )
  const algoliaIndex = useSelector(
    state => state?.login?.checkCompany?.[0].InitialCatalog
  )

  const fulfillmentPlan =
    (useSelectorDetalle.Lines || []).filter(
      item => item.FulfillmentPlanDescription
    )?.[0]?.FulfillmentPlanDescription ?? null

  const [channelList, setChannelList] = useState([])
  const isDistributionSeller = validateRoles(
    user?.AuthenticationInfo?.UserRoles,
    'Vendedor Comercial Distribución'
  )

  const isConstructionSeller = validateRoles(
    user?.AuthenticationInfo?.UserRoles,
    'Vendedor Comercial Construcción'
  )

  const viewProductMargin = useHandlePermission(VAPermissions.seeMargenProd)
  const { showAll, toggleAll, toggleRow, isRowVisible } = useMarginVisibility(
    useSelectorProductos.length
  )

  // columnas ocultas
  const [hiddenColumns, setHiddenColumns] = useState([])
  const [updatedColumnsVisibility, setUpdatedColumnsVisibility] =
    useState(false)
  const hasSavedColumnConfig =
    Boolean(useEstadoGuardar?.QuoteHeader?.Column) &&
    useEstadoGuardar.QuoteHeader.Column.length > 0
  const isColumnsVisibilityReady =
    !hasSavedColumnConfig || updatedColumnsVisibility

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: 'Referencia',
        accessor: 'Referencia',
        Footer: <MarginText />,
        hideEnabled: true,
      },
      {
        Header: 'Número de Parte',
        accessor: 'Número de Parte',
        hideEnabled: true,
      },
      {
        Header: 'Descripción',
        accessor: 'Descripción',
      },
      {
        Header: 'Imagen',
        accessor: 'Imagen',
        hideEnabled: true,
      },
      {
        Header: 'Marca',
        accessor: 'Marca',
        hideEnabled: true,
      },
      {
        Header: 'País de Origen',
        accessor: 'País de Origen',
        hideEnabled: true,
      },
      {
        Header: 'Cantidad',
        accessor: 'Cantidad',
      },
      {
        Header: 'Precio Unitario',
        accessor: 'Precio Unitario',
        ...(!viewProductMargin && { Footer: <SubtotalText /> }),
      },
      {
        Header: 'Descuento',
        accessor: 'Descuento',
        hideEnabled: true,
        ...(!viewProductMargin && { Footer: <SubtotalText /> }),
      },
      {
        Header: 'Precio Total',
        accessor: 'Precio Total',
        Footer: viewProductMargin ? (
          <SubtotalText />
        ) : (
          <SubtotalNumbers setDiscount={setDiscount} />
        ),
      },
    ]

    if (viewProductMargin) {
      baseColumns.push(
        getMarginColumn({
          showAll,
          toggleAll,
          toggleRow,
          isRowVisible,
          footer: <SubtotalNumbers setDiscount={setDiscount} />,
        })
      )
    }

    return baseColumns
  }, [viewProductMargin, showAll, isRowVisible])

  // Load column visibility from saved quote data (e.g. after redirect from edit)
  useEffect(() => {
    if (
      !updatedColumnsVisibility &&
      columns?.length > 0 &&
      useEstadoGuardar?.QuoteHeader?.Column
    ) {
      const newColumns = []
      const items = Object.keys(useEstadoGuardar?.QuoteHeader?.Column[0] || {})
      items.forEach(item => {
        if (useEstadoGuardar?.QuoteHeader?.Column[0][item] !== 0) {
          newColumns.push(item)
        }
      })
      const updateColumns = updateHiddenColumns(newColumns, columns)
      setHiddenColumns(updateColumns || [])
      setUpdatedColumnsVisibility(true)
    }
  }, [useEstadoGuardar, updatedColumnsVisibility, columns])

  const dispatch = useDispatch()

  const Hoy = new Date()
  const dd = String(Hoy.getDate()).padStart(2, '0')
  const mm = String(Hoy.getMonth() + 1).padStart(2, '0') // January is 0!
  const yyyy = Hoy.getFullYear()
  const Fecha = yyyy + '-' + mm + '-' + dd

  const setTableData = data => {
    return data.map(product => {
      const nego = product?.Price ?? 0
      const visitDiscPerUnit =
        product?.VisitDiscountAmount && product?.Quantity
          ? Math.ceil(
              (product.VisitDiscountAmount / product.Quantity) * 10000
            ) / 10000
          : 0

      return {
        ...product,
        Referencia: product?.Sku,
        Descripción: (
          <>
            <div>{getProductDisplayText(product)}</div>
            {product?.ColorVariants && (
              <Tints key={product?.ProductId} tints={product?.ColorVariants} />
            )}
          </>
        ),
        Imagen:
          (product.Images && product.Images[0].URL) ||
          product.DefaultProductPicture ||
          NoImage,
        Marca: product?.Brand,
        'País de Origen': 'Panamá',
        Cantidad: product?.Quantity,
        'Precio Unitario': showDiscountOption
          ? Math.max(nego, product?.BasePrice ?? 0)
          : nego - visitDiscPerUnit,
        Descuento: Number(
          Formatter.Money((product?.DiscountAmount || 0) + visitDiscPerUnit, {
            withFormat: false,
            rounded: true,
          })
        ),
        'Precio Total':
          product?.Price * product?.Quantity -
          (product?.VisitDiscountAmount || 0),
        'Número de Parte': product?.ManufacturerPartNumber || 'Desconocido',
      }
    })
  }

  const productsData = useMemo(
    () => setTableData(useSelectorProductos),
    [showDiscountOption]
  )

  const hasOdv = useEstadoGuardar?.QuoteHeader?.RelationDoc?.find(
    doc =>
      doc?.DocumentNumber?.includes('ODV') ||
      doc?.DocumentTypeId?.toLowerCase()?.includes(
        documentTypeId?.ODV?.toLowerCase()
      )
  )

  const fetchChannel = async () => {
    const Data = await dispatch(getChannelsAction())
    if (Data && Data?.length > 0 && Data?.[0]?.ChannelId) {
      setChannelList(Data)
    }
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const updateQuote = (updatedQuote, action) => {
    dispatch(
      guardarCotizacion(
        updatedQuote,
        props,
        setIsErrorAddressModal,
        setMessageAddressModal,
        setIsLoadingCreateQuote,
        action
      )
    )
  }
  const saveCotizacion = async () => {
    if (comment === null || comment === undefined) {
      setComment('')
      dispatch(addComment(''))
      useEstadoGuardar.QuoteHeader.Comment = ''
    } else {
      useEstadoGuardar.QuoteHeader.Comment = comment
      dispatch(addComment(comment))
    }
    const newColumns = []
    const columnsVisible =
      hiddenColumns.length > 0
        ? hiddenColumns
        : updateHiddenColumns(
            columns
              .filter(column => column.hideEnabled)
              .map(column => column.Header),
            columns
          )

    const partNumberColumn = columnsVisible.find(
      column => column.ColumnName === 'Número de Parte'
    )

    const ShowPartNumber = partNumberColumn?.Status || false

    columnsVisible.forEach(column => {
      newColumns.push({
        ...column,
        DocumentId: useEstadoGuardar.QuoteHeader.QuoteHeaderId,
      })
    })
    if (newColumns.length > 0) {
      useEstadoGuardar.Columns = newColumns
    }

    useEstadoGuardar.QuoteHeader.ServiceNote = getValidServiceNote(quillRef)
    useEstadoGuardar.QuoteHeader.ShowPartNumber = ShowPartNumber

    // Dispatch to Redux for persistence
    dispatch(setServiceNote(useEstadoGuardar.QuoteHeader.ServiceNote))

    const matchedCartItems = matchCartItemsToQuoteLines(
      useEstadoGuardar.QuoteHeader.Lines,
      cartItems
    )
    const mappedLines = useEstadoGuardar.QuoteHeader.Lines.map(
      (linea, index) => {
        // Prefer cart data (most up-to-date) over cotizacion Lines
        const cartItem = matchedCartItems[index]
        const price = Number(cartItem?.Price ?? linea.Price) || 0
        const quantity = Number(cartItem?.Quantity ?? linea.Quantity) || 0
        const additionalDiscountAmount = cartItem?.VisitDiscountAmount || 0
        const taxRate = Number(linea.TaxCategoryValue) || 0
        const visitDiscountPerUnit =
          additionalDiscountAmount > 0 && quantity > 0
            ? Math.ceil((additionalDiscountAmount / quantity) * 10000) / 10000
            : 0
        const effectiveUnitPrice = price - visitDiscountPerUnit
        const discountAmount =
          Math.max((linea.BasePrice || 0) - price, 0) + visitDiscountPerUnit
        const amount = Number(
          Formatter.Money(price * quantity - additionalDiscountAmount, {
            withFormat: false,
          })
        )
        const totalLine = Number(
          Formatter.Money((linea.BasePrice || price) * quantity, {
            withFormat: false,
          })
        )
        const tax = Number(
          Formatter.Money(amount * taxRate, { withFormat: false })
        )
        const amountWithTax = Number(
          Formatter.Money(amount + tax, { withFormat: false })
        )
        return {
          ...linea,
          ...(cartItem
            ? {
                Price: effectiveUnitPrice,
                Quantity: quantity,
              }
            : {}),
          LineNum: index + 1,
          Amount: amount,
          TotalLine: totalLine,
          Tax: tax,
          AmountWithTax: amountWithTax,
          DiscountAmount: discountAmount,
          ...(cartItem?.VisitDiscountType
            ? {
                VisitDiscountType: cartItem.VisitDiscountType,
                VisitDiscountAmount: cartItem.VisitDiscountAmount,
              }
            : {}),
        }
      }
    )

    const headerTax = mappedLines.reduce(
      (sum, line) => sum + (line.Tax || 0),
      0
    )
    const headerDiscountAmount = mappedLines.reduce((sum, line) => {
      const visitDiscount = line.VisitDiscountAmount || 0
      const visitDiscountPerUnit =
        visitDiscount > 0 && line.Quantity > 0
          ? Math.ceil((visitDiscount / line.Quantity) * 10000) / 10000
          : 0
      const negotiatedDiscount =
        Math.max(0, (line.DiscountAmount || 0) - visitDiscountPerUnit) *
        (line.Quantity || 0)
      return sum + negotiatedDiscount + visitDiscount
    }, 0)
    const headerAmount = mappedLines.reduce(
      (sum, line) => sum + (line.Amount || 0),
      0
    )
    const headerAmountWithTax = mappedLines.reduce(
      (sum, line) => sum + (line.AmountWithTax || 0),
      0
    )
    const headerSubTotal = mappedLines.reduce(
      (sum, line) => sum + (line.TotalLine || 0),
      0
    )

    useEstadoGuardar.QuoteHeader = {
      ...useEstadoGuardar.QuoteHeader,
      Telephone: validatorIsCountedCustomer(useEstadoGuardar?.QuoteHeader)
        ? useEstadoGuardar.QuoteHeader.Telephone
        : undefined,
      Lines: mappedLines,
      CustomerId: useEstadoGuardar?.QuoteHeader?.CustomerId,
      Discount: discount,
      Tax: headerTax,
      DiscountAmount: headerDiscountAmount,
      Amount: headerAmount,
      SubTotal: headerSubTotal,
      AmountWithTax: headerAmountWithTax,
      CompanyId: company.CompanyId,
      CompanyCode: company?.CompanyCode,
      WarehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
      WarehouseDescription:
        useSelectorQuoteObject?.QuoteHeader?.WarehouseDescription,
      WarehouseAddress: useSelectorQuoteObject?.QuoteHeader?.WarehouseAddress,
      WarehouseCode: useSelectorQuoteObject?.QuoteHeader?.WarehouseCode,
      WarehouseName: useSelectorQuoteObject?.QuoteHeader?.WarehouseName,
      SalesAgentId:
        useSelectorDetalle?.SalesAgentId || user?.AuthenticationInfo?.UserId,
      AddressId: useSelectorDetalle?.Address_AddressId,
      PromisedDate: promisedDate,
    }

    dispatch({
      type: 'SET_IS_REDIRECT',
      payload: true,
    })

    const updatedQuote = updateSellerIfApplicable(
      useEstadoGuardar,
      user.AuthenticationInfo.UserRoles,
      user.CustomerInfo
    )

    const action = 'editionPage'
    if (hasOdv) {
      setIsLoadingCreateQuote(true)

      const response = await validatorErrorUpdate(
        hasOdv,
        updatedQuote,
        user,
        setIsErrorAddressModal,
        setMessageAddressModal,
        props,
        updatedQuote,
        action
      )

      if (response) return
      updateQuote(updatedQuote, action)
    }
    updateQuote(updatedQuote, action)
  }

  const noChannel = () => {
    saveCotizacion()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const getSkusNoCostProduct = () => {
    const inactiveCodes = prodWithNoCost.map(product => product.Sku)

    const skusProd = inactiveCodes.join(', ')
    return skusProd
  }

  useEffect(() => {
    setComment(useSelectorDetalle.Comment)
    setHasRelationDocs(
      useSelectorDetalle?.RelationDoc &&
        useSelectorDetalle?.RelationDoc.length > 0
    )
  }, [])

  useEffect(() => {
    fetchChannel()
  }, [])

  const fetchODV = async () => {
    const odvDocHeaderId = useSelectorDetalle?.RelationDoc?.find(
      doc =>
        doc.DocumentNumber.includes('ODV') ||
        doc?.DocumentTypeId?.toLowerCase().includes(
          documentTypeId?.ODV?.toLowerCase()
        )
    )?.DocHeaderId
    const response = await searchSalesDocumentDetailService({
      DocumentTypeId: documentTypeId.ODV,
      DocumentHeaderId: odvDocHeaderId,
      DocumentNumber: null,
      PageNumber: 1,
      PageSize: 1,
    })
    const dataFormated = {
      Data: { SalesDocumentInfo: { ...response?.data?.Data } },
    }
    dispatch({ type: 'SELL_ORDER_POST_RESULT', payload: dataFormated })
  }

  const handleModalConfirmStartSalesOrder = () => {
    setShowModalConfirmStartSalesOrder(!showModalConfirmStartSalesOrder)
    !sellOrderPostData && fetchODV()
  }

  const processSalesOrder = async values => {
    dispatch({ type: 'SELL_ORDER_FILE_ATTACHED', payload: values.file })
    dispatch({ type: 'IS_COMMERCIAL_CREDIT_SELECTED', payload: values })
    await generateODV(values)
  }

  const blockGenerateSalesOrderWithError = messageKey => {
    setShowModalGenerateSalesOrder(false)
    setMessageAddressModal({ message: t(messageKey), status: 'error' })
    setIsErrorAddressModal(true)
  }

  const generateODV = async values => {
    const isCreditCommercial = values?.credit === 'yes'
    const creditAccountId = values?.accountItemSelected?.CreditAccountId
    const hasValidCreditAccount =
      isCreditCommercial && creditAccountId && creditAccountId !== EMPTY_GUID

    if (
      existingCreditAccount &&
      hasValidCreditAccount &&
      creditAccountId !== existingCreditAccount.CreditAccountId
    ) {
      blockGenerateSalesOrderWithError(
        'GENERATE_SALES_ORDER_T.CREDIT_ACCOUNT_LOCKED'
      )
      return
    }

    if (isCreditCommercial && !hasValidCreditAccount) {
      blockGenerateSalesOrderWithError(
        'GENERATE_SALES_ORDER_T.INVALID_CREDIT_ACCOUNT'
      )
      return
    }

    const customerId = useSelectorQuoteObject?.QuoteHeader?.CustomerId

    if (hasValidCreditAccount) {
      const isDuplicateOrderNumber = await checkDuplicateOrderNumberForCustomer(
        {
          customerId: customerId || CUSTOMERID,
          orderNumber: sanitizeOrderNumber(values?.orderNumber),
          companyId: useSelectorQuoteObject?.QuoteHeader?.CompanyId,
          excludeDocHeaderId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId,
        }
      )

      if (isDuplicateOrderNumber) {
        blockGenerateSalesOrderWithError(
          'GENERATE_SALES_ORDER_T.DUPLICATE_ORDER_NUMBER'
        )
        return
      }
    }
    const ServiceNote = getValidServiceNote(quillRef)
    // The backend may not populate QuoteHeader.PaymentStatus yet (it's
    // reset to null after a cotizacionReStart) — as a fallback, if the
    // cloned Payments already carries a Yappy payment, treat it as
    // confirmed as well. That fallback only applies when PaymentStatus is
    // unknown (null); an explicit non-confirmed status (pending/failed/
    // expired) must never be overridden just because a Payments entry
    // exists, since entries are created as soon as a payment link is
    // generated, not only once the payment is actually confirmed.
    const yappyPayments = getYappyPayments(
      useSelectorQuoteObject?.QuoteHeader?.Payments
    )
    const paymentStatusUnknown =
      useSelectorQuoteObject?.QuoteHeader?.PaymentStatus == null
    const hasConfirmedYappyPayment =
      isPaymentConfirmed(useSelectorQuoteObject?.QuoteHeader) ||
      (paymentStatusUnknown && yappyPayments.length > 0)
    const yappyPaymentAmount =
      useSelectorQuoteObject?.QuoteHeader?.PaymentAmount ??
      useSelectorQuoteObject?.QuoteHeader?.PaymentTotal

    const payload = {
      documentTypeId: ID_CONSTANTS.salesOrder.sellOrderTypeID,
      salesOrder: {
        PromisedDate: promisedDate,
        addressId: useSelectorDetalle?.Address_AddressId,
        customerId: customerId || CUSTOMERID,
        CustomerEmail: useSelectorQuoteObject?.QuoteHeader?.EmailAddress,
        ...(validatorIsCountedCustomer(useSelectorQuoteObject?.QuoteHeader) && {
          Telephone: useSelectorQuoteObject?.QuoteHeader?.Telephone,
        }),
        customerNameDocument:
          useSelectorQuoteObject?.QuoteHeader?.CustomerNameDocument,
        creditAccountId: hasValidCreditAccount ? creditAccountId : null,
        salesAgentId: useSelectorQuoteObject?.QuoteHeader?.SalesAgentId,
        DocumentDate: useSelectorQuoteObject?.QuoteHeader?.DocumentDate,
        quantity: useSelectorQuoteObject?.QuoteHeader?.Quantity,
        amount: useSelectorQuoteObject?.QuoteHeader?.Amount,
        amountWithTax: useSelectorQuoteObject?.QuoteHeader?.AmountWithTax,
        tax: useSelectorQuoteObject?.QuoteHeader?.Tax,
        cost: useSelectorQuoteObject?.QuoteHeader?.Cost,
        companyId: useSelectorQuoteObject?.QuoteHeader?.CompanyId,
        companyCode: useSelectorQuoteObject?.QuoteHeader?.CompanyCode,
        quoteHeaderId: useSelectorQuoteObject?.QuoteHeader?.QuoteHeaderId,
        salesOrderTypeId:
          values?.credit === 'yes'
            ? salesOrderTypeIds.credito_comercial
            : salesOrderTypeIds.pago_contado,
        HeaderStatusId: ID_CONSTANTS.salesOrder.headerStatusSalesOrderID,
        isDirectDelivery: directdeliveryState ? 1 : 0,
        salesOrderStatusId: ID_CONSTANTS.salesOrder.salesOrderStatusID,
        comments: comment,
        salesAgentEmail: null,
        lines: populateItemsArrayOfPayload(),
        warehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
        warehouseCode: useSelectorQuoteObject?.QuoteHeader?.WarehouseCode,
        origin: useSelectorQuoteObject?.QuoteHeader?.Origin || 'VA',
        ...(sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId && {
          SalesOrderHeaderId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId,
        }),
        ...(sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber && {
          DocumentNumber:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber,
        }),
        Channel,
        CreditAccountId: hasValidCreditAccount ? creditAccountId : null,
        CreditAccountNumber: hasValidCreditAccount
          ? values?.accountItemSelected?.CreditAccountNumber
          : null,
        OrderNumber: hasValidCreditAccount
          ? sanitizeOrderNumber(values?.orderNumber)
          : null,
        ServiceNote,
        IsCatalog: useSelectorQuoteObject?.QuoteHeader?.IsCatalog || false,
        IsService: useSelectorQuoteObject?.QuoteHeader?.IsService || false,
        ...(hasConfirmedYappyPayment &&
          yappyPaymentAmount != null && {
            Payments: [
              {
                PaymentMethodId: 'YAPPY',
                PaymentName: 'Yappy',
                PaymentAmount: yappyPaymentAmount,
                PaymentDate: useSelectorQuoteObject?.QuoteHeader?.PaymentDate,
                PaymentMethodDetails: {
                  PaymentAttributes: [
                    {
                      PaymentTypeAttributeId: 'ConfirmationNumber',
                      CustomInformation:
                        useSelectorQuoteObject?.QuoteHeader
                          ?.YappyConfirmationNumber,
                    },
                  ],
                },
              },
            ],
          }),
      },
    }

    const result = await dispatch(generateSellOrderAction(payload))
    if (result.message !== 'ERROR') {
      if (values.file) {
        await uploadFile({
          file: values.file,
          docData: result.Data.SalesDocumentInfo,
        })
      }

      if (canChangePriceODV && result.Data) {
        const needsPriceApproval = result.Data.SalesDocumentInfo?.Lines?.some(
          line => line.Price < line.FinalPrice && !line.AuthorizedPriceBy
        )
        if (needsPriceApproval) {
          const variables = {
            saleOrderDocHeaderId: result?.Data?.SalesDocumentInfo?.DocHeaderId,
            saleOrderDocumentNumber:
              result?.Data?.SalesDocumentInfo.DocumentNumber,
            user: user?.AuthenticationInfo,
          }
          await updateProductsAuth(variables)
        }
      }
      dispatch({
        type: 'SET_PREORDER_VALIDATION',
        payload: true,
      })

      dispatch({
        type: 'SET_IS_DIRECT_DELIVERY',
        payload: directdeliveryState,
      })

      dispatch({
        type: 'SET_IS_REDIRECT',
        payload: false,
      })

      dispatch({ type: 'CLEAN_COMMERCIAL_CREDIT_SELECTED' })

      const relatedQuote = result.Data.SalesDocumentInfo?.RelationDoc?.find(
        doc =>
          doc.DocumentTypeId?.toLowerCase() ===
          documentTypeId.QUOTATION.toLowerCase()
      )
      const quoteDocHeaderId = relatedQuote?.DocHeaderId
      if (quoteDocHeaderId && quoteDocHeaderId !== EMPTY_GUID) {
        const columnsVisible =
          hiddenColumns.length > 0
            ? hiddenColumns
            : updateHiddenColumns(
                columns
                  .filter(column => column.hideEnabled)
                  .map(column => column.Header),
                columns
              )
        try {
          const quoteDetailResponse = await dispatch(
            searchSalesDocumentDetail({
              DocumentTypeId: documentTypeId.QUOTATION,
              DocumentHeaderId: quoteDocHeaderId,
              DocumentNumber: relatedQuote?.DocumentNumber,
              PageNumber: 1,
              PageSize: 1,
            })
          )
          if (quoteDetailResponse?.Data) {
            const quotation = {
              DocumentTypeId: documentTypeId.QUOTATION,
              QuoteHeader: {
                ...quoteDetailResponse.Data,
                QuoteHeaderId: quoteDocHeaderId,
              },
            }
            await dispatch(saveQuoteColumnsSilent(quotation, columnsVisible))
          }
        } catch (err) {
          console.error(
            'Error saving column visibility after ODV creation:',
            err
          )
        }
      }

      const route = `/orden_de_venta/created/${result.Data.SalesDocumentInfo?.DocHeaderId}`
      history.push(route)
    } else {
      setShowFailedSellOrderState(true)
    }
  }

  // AQUI TENGO QUE MODIFICAR
  const populateItemsArrayOfPayload = () => {
    const arrayOfItems = []

    useSelectorQuoteObject?.QuoteHeader?.Lines.forEach((lineItem, i) => {
      const cartItem = cartItems.find(c => c.ProductId === lineItem.ProductId)

      const additionalDiscountAmount = cartItem?.VisitDiscountAmount || 0
      const quantity = lineItem?.Quantity || 0
      const basePrice = Number(cartItem?.Price ?? lineItem.Price) || 0
      const visitDiscountPerUnit =
        additionalDiscountAmount > 0 && quantity > 0
          ? Math.ceil((additionalDiscountAmount / quantity) * 10000) / 10000
          : 0
      const effectiveUnitPrice = basePrice - visitDiscountPerUnit
      const discountAmount =
        Math.max((lineItem.BasePrice || 0) - basePrice, 0) +
        visitDiscountPerUnit
      const taxRate = Number(lineItem.TaxCategoryValue) || 0
      const amount = Number(
        Formatter.Money(basePrice * quantity - additionalDiscountAmount, {
          withFormat: false,
        })
      )
      const tax = Number(
        Formatter.Money(amount * taxRate, { withFormat: false })
      )
      const amountWithTax = Number(
        Formatter.Money(amount + tax, { withFormat: false })
      )

      const visitDiscountType =
        cartItem?.VisitDiscountType ?? lineItem?.VisitDiscountType
      const visitDiscountAmount =
        cartItem?.VisitDiscountAmount ?? lineItem?.VisitDiscountAmount

      const payloadFormation = {
        ...(sellOrderPostData?.Data?.SalesDocumentInfo?.Lines && {
          SalesOrderLineId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.Lines?.find(
              prod =>
                prod.ProductId?.toLowerCase() ===
                lineItem?.ProductId?.toLowerCase()
            )?.DocLineId || '00000000-0000-0000-0000-000000000000',
        }),
        productId: lineItem?.ProductId,
        priceListId: lineItem?.PriceListId,
        warehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
        quantity: lineItem?.Quantity,
        amount,
        amountWithTax,
        BasePrice: lineItem?.BasePrice,
        DiscountAmount: discountAmount,
        FinalPrice: lineItem?.FinalPrice,
        tax,
        cost: lineItem?.Cost,
        price: effectiveUnitPrice,
        lineNum: i + 1,
        qtyOrdered: lineItem?.Quantity,
        qtyDelivered: 0,
        qtyCanceled: 0,
        qtyOutstanding: 0,
        isDirectDelivery: lineItem?.IsDirectDelivery,
        ...(effectiveUnitPrice < lineItem?.FinalPrice && {
          NegotiatedPriceBy: lineItem.NegotiatedPriceBy,
          NegotiatedPriceByName: lineItem.NegotiatedPriceByName,
        }),
        ColorVariants: lineItem?.ColorVariants,
        FulfillmentPlanId: lineItem?.FulfillmentPlanId,
        FulfillmentPlanDescription: lineItem?.FulfillmentPlanDescription,
        VisitDiscountType: visitDiscountType,
        VisitDiscountAmount: visitDiscountAmount,
      }

      const cleanEntries = Object.fromEntries(
        Object.entries(payloadFormation).filter(([_, v]) => v != null)
      )

      arrayOfItems.push(cleanEntries)
    })

    return arrayOfItems
  }
  const generateSalesOrder = () => {
    dispatch({
      type: 'CLEAN_SELL_ORDER',
      payload: null,
    })
    handleModalConfirmStartSalesOrder()
  }

  useMemo(() => {
    setCreateOdv(param?.type_document === 'sales_order')

    if (param?.type_document === 'sales_order') {
      dispatch(
        creditAccountsAction({
          customerId: useSelectorDetalle?.CustomerId,
          companyId: useSelectorDetalle?.CompanyId,
        })
      )
    }
  }, [])

  const handleAddPurchaseOrder = () => {
    const lines = useSelectorProductos

    aa('purchasedObjectIDsAfterSearch', {
      userToken: aa('getUserToken'),
      eventName: 'ADD_PURCHASE_ORDER',
      index: algoliaIndex,
      objectIDs: lines.flatMap(({ objectID }) => objectID || []),
      objectData: lines.map(({ queryID, FinalPrice, Discount, Quantity }) => ({
        queryID,
        Price: FinalPrice,
        discount: Discount || 0,
        Quantity,
      })),
      value: lines
        .reduce((total, { FinalPrice, TaxCategoryValue, Quantity }) => {
          // Calcular el total por línea considerando FinalPrice, Taxes y Quantity
          const totalLine =
            (FinalPrice + FinalPrice * (TaxCategoryValue || 0)) * Quantity
          return total + totalLine
        }, 0)
        .toFixed(2),
      currency: 'USD',
    })
  }

  const checkRelationDocs = () => {
    handleAddPurchaseOrder()
    if (createOdv) {
      generateSalesOrder()
    } else {
      if (hasRelationDocs) {
        setShowChangesODVAlert(hasRelationDocs)
      } else {
        setShowChangesODVAlert(false)
        Channel ? noChannel() : handleOpen()
      }
    }
  }

  const handleModalGenerateSalesOrder = () => {
    setShowModalGenerateSalesOrder(!showModalGenerateSalesOrder)
  }

  useEffect(() => {
    if (confirmStartSalesOrder) {
      setConfirmStartSalesOrder(false)
      handleModalGenerateSalesOrder()
    }
  }, [confirmStartSalesOrder])

  const hiddenColumnDiscount = bool => {
    if (bool !== showDiscountOption) {
      dispatch(mostrarDescuento(bool))
    }
  }

  const getArrayHiddenColumns = hiddenColumns => {
    const hiddenColumnsCopy = hiddenColumns.filter(column =>
      column.Status === false ? column.ColumnName : false
    )
    return hiddenColumnsCopy.map(column => column.ColumnName)
  }

  useEffect(() => {
    // Don't overwrite the LITA channel: this default is for the ODV-without-
    // quote flow and must not affect the LITA seller auto-update feature.
    if (litaAutoGeneratedChannels.includes(Channel)) return
    if (isConstructionSeller) {
      return dispatch(addChannel('Ventas a clientes – Construcción'))
    } else if (isDistributionSeller) {
      return dispatch(addChannel('Ventas a clientes – Distribución'))
    }
  }, [Channel, isConstructionSeller, isDistributionSeller])

  return (
    <>
      <Navigation />
      <ModalAlertCart preQuote={true} shopping={false} saleProduct={false} />
      <div
        className="cotizacion-generada-container"
        data-testid="container-generate-quote">
        <div
          className="cotizacion-generada"
          data-testid="container-quote-detail">
          <h2 className="titulo-cotizacion" data-testid="title-quote-detail">
            Detalle de cotización
          </h2>
          <p className="alert-document">
            Verifica que los datos en la cotización creada sean los correctos
          </p>
          <div className="info-general" data-testid="container-general-info">
            <div
              className="info-general-cliente"
              data-testid="container-customer-info">
              <p data-testid="text-customer-name">
                Cliente: {useSelectorDetalle.CustomerNameDocument}
              </p>
              <p data-testid="text-customer-email">
                Email:{' '}
                {useSelectorDetalle.EmailAddress ||
                  useSelectorDetalle.CustomerEmail ||
                  'Sin información'}
              </p>
              <p data-testid="text-customer-phone">
                Teléfono:{' '}
                {useSelectorDetalle.Telephone ||
                  useSelectorDetalle.Telephone_Number ||
                  'Sin información'}
              </p>
            </div>
            <div
              className="info-general-retiro"
              data-testid="container-delivery-info">
              {useSelectorDetalle?.Address_AddressId ? (
                <>
                  <p data-testid="text-delivery-type">Envío a domicilio</p>
                  <p data-testid="text-address-street">
                    {t('Address', {
                      value: isWebDocumentOrigin(useSelectorDetalle?.Origin)
                        ? useSelectorDetalle?.QuoteAddressStreet ||
                          useSelectorDetalle?.QuoteAddressDetail ||
                          t('whithoutDatail')
                        : useSelectorDetalle?.Address_Street ||
                          useSelectorDetalle?.QuoteAddressStreet ||
                          t('whithoutDatail'),
                    })}
                  </p>
                  <p data-testid="text-address-district">
                    {`${useSelectorDetalle.Address_DistrictName}, ${useSelectorDetalle.Address_CountryName}`}
                  </p>
                  <p data-testid="text-address-alias">
                    {t('Alias', {
                      value: isWebDocumentOrigin(useSelectorDetalle?.Origin)
                        ? useSelectorDetalle?.Address_AddressName ||
                          useSelectorDetalle?.Name ||
                          t('whithoutDatail')
                        : useSelectorDetalle.Address_AddressDetail ||
                          useSelectorDetalle.QuoteAddressDetail ||
                          t('whithoutDatail'),
                    })}
                  </p>
                  <p data-testid="text-address-phone">
                    {t('Phone', {
                      value:
                        useSelectorDetalle?.Address_Telephone_Number ||
                        t('whithoutDatail'),
                    })}
                  </p>
                  <DeliveryDateLabel date={promisedDate} variant="delivery" />
                </>
              ) : (
                <>
                  <p data-testid="text-delivery-type">Retiro en sucursal</p>
                  <p data-testid="text-warehouse-address">
                    {useSelectorDetalle.WarehouseAddress}
                  </p>
                  <p data-testid="text-warehouse-description">
                    {useSelectorDetalle.WarehouseDescription}
                  </p>
                  <p data-testid="text-warehouse-code">
                    {useSelectorDetalle.WarehouseCode}
                  </p>
                  <DeliveryDateLabel date={promisedDate} variant="pickup" />
                </>
              )}
              {fulfillmentPlan && <p>Plan de entrega: {fulfillmentPlan}</p>}
            </div>
            <div
              className="info-general-vendedor"
              data-testid="container-seller-info">
              <p data-testid="text-seller-name">
                Vendedor: {useSelectorDetalle.SalesAgentFullName}
              </p>
              <p data-testid="text-quote-date">Fecha: {FormatedDate(Fecha)}</p>
            </div>
          </div>
          <QuotationPdfOptions />
          {hasProdWithNoCost ? (
            <div
              className="sell-order-product-advice"
              data-testid="container-zero-cost-alert">
              <p>
                <span className="info-advice-text-title">Nota: </span>
                No se puede generar una cotización con productos de costo cero (
                {getSkusNoCostProduct()}). Por favor, revisa los costos con
                compras antes de continuar.
              </p>
            </div>
          ) : null}
          {isColumnsVisibilityReady ? (
            <FilteringTable
              data={productsData}
              prodWithNoCost={prodWithNoCost}
              columns={columns}
              // showMargin={showAll}
              isProductPage={true}
              setHiddenColumns={columns => setHiddenColumns(columns)}
              hiddenColumns={getArrayHiddenColumns(hiddenColumns)}
              hiddenColumnDiscount={bool => {
                hiddenColumnDiscount(bool)
              }}
              showDiscountOption={showDiscountOption}
            />
          ) : null}
        </div>
        <AdditionalServiceDetailsEditor ref={quillRef} />
        <div
          className="cotizacion-generada-documento"
          data-testid="container-attached-document">
          <div data-testid="container-attach-file">
            <h2 style={{ fontSize: '16px' }}>Adjuntar documento</h2>
            <div className="adjuntar">
              <label
                htmlFor="cotizacion-file-upload"
                data-testid="btn-browse-file">
                <BoxArrowUp /> Examinar
              </label>
              <input
                id="cotizacion-file-upload"
                type="file"
                data-testid="input-file-quote"
              />
            </div>
          </div>
          <div data-testid="container-comment">
            <h2 style={{ fontSize: '16px' }}>Agregar comentario</h2>
            <textarea
              value={comment || ''}
              onChange={e => setComment(e.target.value)}
              maxLength={5000}
              data-testid="input-comment-quote"
            />
          </div>
        </div>
        <div
          className="cotizacion-save-button"
          data-testid="container-quote-actions">
          <button
            onClick={() => checkRelationDocs()}
            className="guardar_button"
            data-testid="btn-save-quote">
            {isLoadingCreateQuote ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner" />
            ) : createOdv ? (
              'Guardar orden de venta'
            ) : (
              'Guardar'
            )}
          </button>
        </div>
        <Modal
          open={showChangesODVAlert}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          data-testid="modal-confirm-odv-changes">
          <Box>
            <GenericModal
              hideCheck={true}
              showCaution={false}
              setConfirm={() => {
                setShowChangesODVAlert(false)
                Channel ? noChannel() : handleOpen()
              }}
              setIsOpen={() => setShowChangesODVAlert(false)}
              text={
                '¿Estás seguro que deseas aplicar los cambios en la cotización?'
              }
              text2={'Estos cambios actualizarán la orden de venta generada'}
              mostrarButtons={true}
              closeLessPadding={true}
              gapTexts={true}></GenericModal>
          </Box>
        </Modal>
        <Modal
          open={showFailedSellOrderState}
          onClose={() => {
            setShowFailedSellOrderState(false)
          }}
          data-testid="modal-error-sales-order">
          <Box>
            <GenericModal
              hideCheck={true}
              showCaution={true}
              setConfirm={() => {}}
              setIsOpen={() => setShowFailedSellOrderState(false)}
              text={'No se ha podido crear la orden de venta'}
              mostrarButtons={false}></GenericModal>
          </Box>
        </Modal>
        {/* Modal confirmar iniciar orden de venta */}
        <Modal
          open={showModalConfirmStartSalesOrder}
          data-testid="modal-confirm-start-sales-order">
          <Box>
            <ConfirmStartSalesOrder
              setShowModalConfirmStartSalesOrder={
                handleModalConfirmStartSalesOrder
              }
              setConfirmStartSalesOrder={setConfirmStartSalesOrder}
              processSalesOrder={processSalesOrder}
            />
          </Box>
        </Modal>
        {/* Modal generar orden de venta */}
        <Modal
          open={showModalGenerateSalesOrder}
          data-testid="modal-generate-sales-order">
          <Box>
            <GenerateSalesOrder
              setShowModalGenerateSalesOrder={handleModalGenerateSalesOrder}
              processSalesOrder={processSalesOrder}
              originalCreditAccount={existingCreditAccount}
            />
          </Box>
        </Modal>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          data-testid="modal-select-channel">
          <Box
            className="modal-box-channel"
            data-testid="container-modal-channel">
            <div className="closing-button">
              <img
                src={No}
                onClick={handleClose}
                alt="close"
                data-testid="btn-close-modal-channel"
              />
            </div>
            <div
              className="modal-box-channel-content"
              data-testid="container-channel-content">
              <div className="modal-box-channel-heading">
                <h2 data-testid="title-select-channel">
                  Selecciona el canal por donde entró la solicitud
                </h2>
              </div>
              <ul className="modal-box-channels" data-testid="list-channels">
                {channelList?.map(({ ChannelId, Channel }) => (
                  <li key={ChannelId} data-testid={`item-channel-${ChannelId}`}>
                    <input
                      type="radio"
                      name="canal"
                      id={Channel}
                      value={Channel}
                      onClick={({ target }) => {
                        dispatch(addChannel(target.value))
                      }}
                      data-testid={`input-radio-channel-${ChannelId}`}
                    />
                    <label
                      htmlFor={Channel}
                      data-testid={`label-channel-${ChannelId}`}>
                      {Channel}
                    </label>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => {
                  handleClose()
                  saveCotizacion()
                }}
                data-testid="btn-continue-channel">
                Continuar
              </button>
            </div>
          </Box>
        </Modal>
        <ModalAlertGeneric
          isError={isErrorAddressModal}
          setIsError={setIsErrorAddressModal}
          messageSettings={messageAddressModal}
          setMessageSettings={setMessageAddressModal}
        />
      </div>
    </>
  )
}

export default GenerarCotizacion
